import {
  getGoogleConnectionUrlService,
  getGoogleConnectionStatusService,
  getGoogleCalendarsService,
  selectGoogleCalendarsService,
  disconnectGoogleService
} from 'Services'
import { useState } from 'react'

export default function useCalendarIntegration () {
  const [loadingCalendarIntegrationHook, setLoadingCalendarIntegrationHook] = useState(false)
  const [listGoogleCalendarsHook, setListGoogleCalendarsHook] = useState([])
  const [connectionStatusHook, setConnectionStatusHook] = useState({ connected: false, google_account_email: null, calendars: [] })

  const getConnectionStatusHook = async () => {
    try {
      setLoadingCalendarIntegrationHook(true)
      const res = await getGoogleConnectionStatusService()

      setConnectionStatusHook(res.data)

      return {
        success: true,
        data: res.data
      }
    } catch (e) {
      return {
        success: false,
        message: e?.response?.data?.message || 'An error occurred while retrieving the Google Calendar connection status. Please try again later.'
      }
    } finally {
      setLoadingCalendarIntegrationHook(false)
    }
  }

  const connectGoogleHook = async () => {
    try {
      setLoadingCalendarIntegrationHook(true)
      const res = await getGoogleConnectionUrlService()

      return {
        success: true,
        data: res.data
      }
    } catch (e) {
      return {
        success: false,
        message: e?.response?.data?.message || 'An error occurred while connecting to Google Calendar. Please try again later.'
      }
    } finally {
      setLoadingCalendarIntegrationHook(false)
    }
  }

  const getGoogleCalendarsHook = async () => {
    try {
      setLoadingCalendarIntegrationHook(true)
      const res = await getGoogleCalendarsService()

      setListGoogleCalendarsHook(res.data.calendars)

      return {
        success: true,
        data: res.data
      }
    } catch (e) {
      return {
        success: false,
        message: e?.response?.data?.message || 'An error occurred while retrieving your Google calendars. Please try again later.'
      }
    } finally {
      setLoadingCalendarIntegrationHook(false)
    }
  }

  const selectGoogleCalendarsHook = async ({ calendarIds }) => {
    try {
      setLoadingCalendarIntegrationHook(true)
      await selectGoogleCalendarsService({ calendarIds })

      return {
        success: true
      }
    } catch (e) {
      return {
        success: false,
        message: e?.response?.data?.message || 'An error occurred while saving your calendar selection. Please try again later.'
      }
    } finally {
      setLoadingCalendarIntegrationHook(false)
    }
  }

  const disconnectGoogleHook = async () => {
    try {
      setLoadingCalendarIntegrationHook(true)
      await disconnectGoogleService()

      return {
        success: true
      }
    } catch (e) {
      return {
        success: false,
        message: e?.response?.data?.message || 'An error occurred while disconnecting Google Calendar. Please try again later.'
      }
    } finally {
      setLoadingCalendarIntegrationHook(false)
    }
  }

  return {
    loadingCalendarIntegrationHook,
    listGoogleCalendarsHook,
    connectionStatusHook,
    getConnectionStatusHook,
    connectGoogleHook,
    getGoogleCalendarsHook,
    selectGoogleCalendarsHook,
    disconnectGoogleHook
  }
}
